import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Typography, Button, Popover } from "@material-ui/core";
import { ExpandLess, ExpandMore, OpenInNew } from "@material-ui/icons";
import * as Routes from "../../../constants/routes";
import * as Permissions from "../../../constants/permissions";
import { analytics } from "../../../services/firebase";
import { PORTAFOLIO } from "../../../constants/urls";
import "../style.css";
import "./../../../App.css";

export default function MasAccesos(props) {
  const {
    anchorAccesos,
    handleClickAccesos,
    openPopoverAccesos,
    handleCloseAccesos,
    setAnchorAccesos,
    handleClickCydocs,
    openPopoverCydocs,
    handleCloseCydocs,
    setAnchorCydocs,
    handleClickReclutamiento,
    openPopoverReclutamiento,
    handleCloseReclutamiento,
    setAnchorReclutamiento,
    anchorReclutamiento,
    idCydocs,
    idAccesos,
    idReclutamiento,
    permisos,
    claimUser,
    anchorCydocs,
  } = props;

  return (
    <Fragment>
      <a
        onClick={handleClickAccesos}
        style={{ color: "#731f1f", textDecoration: "none", cursor: "pointer" }}
      >
        <strong>+ Accesos</strong>
      </a>
      <Popover
        id={idAccesos}
        open={openPopoverAccesos}
        anchorEl={anchorAccesos}
        onClose={handleCloseAccesos}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          style: {
            width: "15%",
            minWidth: "300px",
          },
        }}
      >
        <div style={{ margin: 10 }}>
          {/* PARA GERENTES */}
          {permisos && permisos[Permissions.VER_ACCESOS_GERENTES] && (
            <Button
              component={Link}
              to={Routes.GERENTES}
              style={{
                color: "#731f1f",
                textDecoration: "none",
                textTransform: "none",
                width: "100%",
                justifyContent: "left",
              }}
              onClick={() => {
                analytics.logEvent(
                  "Home_link_superior_Para_Gerentes_Ingeniería",
                  {
                    usuarioCorreo: claimUser.email,
                    usuarioNombre: claimUser.name,
                    usuarioContrato: claimUser.proyecto,
                  }
                );
                setAnchorAccesos(null);
              }}
            >
              <strong>Para Gerentes</strong>
            </Button>
          )}

          {/* CYDOCS ADMINISTRACIÓN */}
          <Button
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "left",
            }}
            onClick={handleClickCydocs}
          >
            <strong>CyDocs Administración</strong>
            {openPopoverCydocs ? (
              <ExpandLess color="primary" />
            ) : (
              <ExpandMore color="primary" />
            )}
          </Button>
          <Popover
            id={idCydocs}
            open={openPopoverCydocs}
            anchorEl={anchorCydocs}
            onClose={handleCloseCydocs}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Typography style={{ padding: "0.5rem" }}>
              {/* Portafolio */}
              <Button
                component="a"
                href={`${PORTAFOLIO}`}
                target="_blank"
                style={{
                  color: "#731f1f",
                  textDecoration: "none",
                  textTransform: "none",
                  width: "100%",
                  justifyContent: "space-between",
                }}
                onClick={() => {
                  analytics.logEvent("Home_link_superior_Portafolio", {
                    usuarioCorreo: claimUser.email,
                    usuarioNombre: claimUser.name,
                    usuarioContrato: claimUser.proyecto,
                  });
                  setAnchorCydocs(null);
                  setAnchorAccesos(null);
                  setAnchorReclutamiento(null);
                }}
                endIcon={
                  <OpenInNew
                    style={{ color: "lightgray", verticalAlign: "middle" }}
                  />
                }
              >
                <strong>Portafolio</strong>
              </Button>

              {/* Administración CyD */}
              <Button
                component="a"
                href="https://administracion.cydocs.cl/"
                target="_blank"
                style={{
                  color: "#731f1f",
                  textDecoration: "none",
                  textTransform: "none",
                  width: "100%",
                  justifyContent: "space-between",
                }}
                onClick={() => {
                  analytics.logEvent("Home_link_superior_Administración_CyD", {
                    usuarioCorreo: claimUser.email,
                    usuarioNombre: claimUser.name,
                    usuarioContrato: claimUser.proyecto,
                  });
                  setAnchorCydocs(null);
                  setAnchorAccesos(null);
                }}
                endIcon={
                  <OpenInNew
                    style={{ color: "lightgray", verticalAlign: "middle" }}
                  />
                }
              >
                <strong>Administración CyD</strong>
              </Button>

              {/* Administración CDZ */}
              {/* <Button
                component="a"
                href="https://script.google.com/a/macros/cydingenieria.cl/s/AKfycbzBb4gDIQl7OgbTvHgzFLL_62o6RJYmlitD3blsKgJ-oOI6ILnO/exec"
                target="_blank"
                style={{
                  color: "#731f1f",
                  textDecoration: "none",
                  textTransform: "none",
                  width: "89%",
                  justifyContent: "left",
                }}
                onClick={() => {
                  analytics.logEvent(
                    "Home_link_superior_Administracion_CDZ",
                    {
                      usuarioCorreo: claimUser.email,
                      usuarioNombre: claimUser.name,
                      usuarioContrato: claimUser.proyecto,
                    }
                  );
                  setAnchorCydocs(null);
                  setAnchorAccesos(null);
                }}
              >
                <strong>Administración CDZ</strong>
              </Button>
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />

              <br /> */}
              {/* Sistema de adquisiciones */}
              {/* <Button
                component="a"
                href="https://test-sda.cydocs.cl/"
                target="_blank"
                style={{
                  color: "#731f1f",
                  textDecoration: "none",
                  textTransform: "none",
                }}
                onClick={() => {
                  analytics.logEvent(
                    "Home_link_superior_Sistema_de_adquisiciones",
                    {
                      usuarioCorreo: claimUser.email,
                      usuarioNombre: claimUser.name,
                      usuarioContrato: claimUser.proyecto,
                    }
                  );
                  setAnchorCydocs(null);
                  setAnchorAccesos(null);
                }}
              >
                <strong>Sistema de Adquisiciones</strong>
              </Button>
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />

              <br /> */}
              {/* Sistema gestor de pagos */}
              {/* <Button
                component="a"
                href="https://test-gestor-pagos.cydocs.cl/"
                target="_blank"
                style={{
                  color: "#731f1f",
                  textDecoration: "none",
                  textTransform: "none",
                }}
                onClick={() => {
                  analytics.logEvent(
                    "Home_link_superior_Sistema_gestor_de_pagos",
                    {
                      usuarioCorreo: claimUser.email,
                      usuarioNombre: claimUser.name,
                      usuarioContrato: claimUser.proyecto,
                    }
                  );
                  setAnchorCydocs(null);
                  setAnchorAccesos(null);
                }}
              >
                <strong>Sistema Gestor de Pagos</strong>
              </Button>
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              /> */}
            </Typography>
          </Popover>

          {/* ACCESO PROYECTOS */}
          {/* <Button
            component="a"
            href="http://201.238.203.174:5501/"
            target="_blank"
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {
              analytics.logEvent("Home_link_superior_Acceso_Proyectos", {
                usuarioCorreo: claimUser.email,
                usuarioNombre: claimUser.name,
                usuarioContrato: claimUser.proyecto,
              });
              setAnchorAccesos(null);
            }}
            endIcon={
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />
            }
          >
            <strong>Acceso Proyectos</strong>
          </Button> */}

          {/* CONSULTA DIGITAL */}
          <Button
            component="a"
            href="https://sites.google.com/cydingenieria.cl/recomendacionesdigitales"
            target="_blank"
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {
              analytics.logEvent("Home_link_superior_Consulta_digital", {
                usuarioCorreo: claimUser.email,
                usuarioNombre: claimUser.name,
                usuarioContrato: claimUser.proyecto,
              });
              setAnchorAccesos(null);
            }}
            endIcon={
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />
            }
          >
            <strong>Consulta Digital</strong>
          </Button>

          {/* RECLUTADORES
          {permisos && permisos[Permissions.VER_ACCESOS_RECLUTADORES] && (
            <Fragment>
              <Button
                style={{
                  color: "#731f1f",
                  textDecoration: "none",
                  textTransform: "none",
                  width: "100%",
                  justifyContent: "left",
                }}
                onClick={handleClickReclutamiento}
              >
                <strong>Reclutadores</strong>
                {openPopoverReclutamiento ? (
                  <ExpandLess color="primary" />
                ) : (
                  <ExpandMore color="primary" />
                )}
              </Button>
              <Popover
                id={idReclutamiento}
                open={openPopoverReclutamiento}
                anchorEl={anchorReclutamiento}
                onClose={handleCloseReclutamiento}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  style: {
                    width: "15%",
                    minWidth: "300px",
                  },
                }}
              >
                <Typography style={{ padding: "0.5rem" }}>
                  {/* Reclutamiento */}
                  {/* <Button
                    component="a"
                    href="https://reclutamiento.cydingenieria.com/"
                    target="_blank"
                    style={{
                      color: "#731f1f",
                      textDecoration: "none",
                      textTransform: "none",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                    onClick={() => {
                      analytics.logEvent(
                        "Home_link_superior_Reclutamiento_Gestor-de-Reclutamiento",
                        {
                          usuarioCorreo: claimUser.email,
                          usuarioNombre: claimUser.name,
                          usuarioContrato: claimUser.proyecto,
                        }
                      );
                      setAnchorCydocs(null);
                      setAnchorAccesos(null);
                      setAnchorReclutamiento(null);
                    }}
                    endIcon={
                      <OpenInNew
                        style={{ color: "lightgray", verticalAlign: "middle" }}
                      />
                    }
                  >
                    <strong>Gestor de Reclutamiento</strong>
                  </Button> */}

                 
                  {/* <Button
                    component="a"
                    href="https://sites.google.com/cydingenieria.cl/gestordereclutamiento"
                    target="_blank"
                    style={{
                      color: "#731f1f",
                      textDecoration: "none",
                      textTransform: "none",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                    onClick={() => {
                      analytics.logEvent(
                        "Home_link_superior_Reclutamiento_Ayuda",
                        {
                          usuarioCorreo: claimUser.email,
                          usuarioNombre: claimUser.name,
                          usuarioContrato: claimUser.proyecto,
                        }
                      );
                      setAnchorCydocs(null);
                      setAnchorAccesos(null);
                      setAnchorReclutamiento(null);
                    }}
                    endIcon={
                      <OpenInNew
                        style={{ color: "lightgray", verticalAlign: "middle" }}
                      />
                    }
                  >
                    <strong>Ayuda Gestor de Reclutamiento</strong>
                  </Button>

                  
                  <Button
                    component="a"
                    href="https://reclutamiento.cydingenieria.cl/in2/"
                    target="_blank"
                    style={{
                      color: "#731f1f",
                      textDecoration: "none",
                      textTransform: "none",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                    onClick={() => {
                      analytics.logEvent(
                        "Home_link_superior_Reclutamiento_Trabaja-con-nosotros",
                        {
                          usuarioCorreo: claimUser.email,
                          usuarioNombre: claimUser.name,
                          usuarioContrato: claimUser.proyecto,
                        }
                      );
                      setAnchorCydocs(null);
                      setAnchorAccesos(null);
                      setAnchorReclutamiento(null);
                    }}
                    endIcon={
                      <OpenInNew
                        style={{ color: "lightgray", verticalAlign: "middle" }}
                      />
                    }
                  >
                    <strong>Trabaja con Nosotros</strong>
                  </Button>

                  
                  <Button
                    component="a"
                    href="https://docs.google.com/forms/d/e/1FAIpQLSc2_otUm95E2UNiXdiV3ApqnHqmRRh8Zy3dV1AeskIsZWT7Sg/viewform"
                    target="_blank"
                    style={{
                      color: "#731f1f",
                      textDecoration: "none",
                      textTransform: "none",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                    onClick={() => {
                      analytics.logEvent(
                        "Home_link_superior_Reclutamiento_Registro-alumno-en-práctica",
                        {
                          usuarioCorreo: claimUser.email,
                          usuarioNombre: claimUser.name,
                          usuarioContrato: claimUser.proyecto,
                        }
                      );
                      setAnchorCydocs(null);
                      setAnchorAccesos(null);
                      setAnchorReclutamiento(null);
                    }}
                    endIcon={
                      <OpenInNew
                        style={{ color: "lightgray", verticalAlign: "middle" }}
                      />
                    }
                  >
                    <strong>Registro Alumno en Práctica</strong>
                  </Button>
                </Typography>
              </Popover>
            </Fragment>
          )} */}

          {/* GESTOR DE CONTRATACIONES */}
          {permisos && permisos[Permissions.VER_CONTRATACIONES] && (
            <Button
              component="a"
              href="https://www.appsheet.com/start/d72fe082-0e7b-4eee-8fc2-682d1dafdf3c?platform=desktop#appName=GestorPer%C3%BA30-726723367&vss=H4sIAAAAAAAAA62PvQrCMBSFX0XOnCfIKg5FdFFcjENMbiHYJiVJ1RLy7ib-IDgWx3sO38e5CVdDt12U6gJ-TN9rTRM4ksB-GkiACyydjd51AkxgK_tX2FijjPSLwTtFwQlk5BP7aCIF8DTLwv-yhcFostG0hnxVVkFRvfFSV7gEPygyQz9Gee7o-UVBcy5Z69QYSB_KsPmDQmNX90FavXG6mFvZBcoPp2VUEogBAAA=&view=Iniciar%20proceso"
              target="_blank"
              style={{
                color: "#731f1f",
                textDecoration: "none",
                textTransform: "none",
                width: "100%",
                justifyContent: "space-between",
              }}
              onClick={() => {
                analytics.logEvent("Home_link_superior_Gestor_Contrataciones", {
                  usuarioCorreo: claimUser.email,
                  usuarioNombre: claimUser.name,
                  usuarioContrato: claimUser.proyecto,
                });
                setAnchorAccesos(null);
              }}
              endIcon={
                <OpenInNew
                  style={{ color: "lightgray", verticalAlign: "middle" }}
                />
              }
            >
              <strong>Gestor de Contrataciones</strong>
            </Button>
          )}

          {/* SISTEMA DE GESTIÓN DE ACTIVOS */}
          <Button
            component="a"
            href="https://activos.cydingenieria.com"
            target="_blank"
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {
              analytics.logEvent("Home_link_superior_gestion_activos", {
                usuarioCorreo: claimUser.email,
                usuarioNombre: claimUser.name,
                usuarioContrato: claimUser.proyecto,
              });
              setAnchorAccesos(null);
            }}
            endIcon={
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />
            }
          >
            <strong>Sistema de Gestión de Activos</strong>
          </Button>

          {/* SISTEMA DE Gestion de Desempeño */}
          <Button
            component="a"
            href="https://evaluacion.cydingenieria.com"
            target="_blank"
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {
              analytics.logEvent("Home_link_superior_gestion_desempeño", {
                usuarioCorreo: claimUser.email,
                usuarioNombre: claimUser.name,
                usuarioContrato: claimUser.proyecto,
              });
              setAnchorAccesos(null);
            }}
            endIcon={
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />
            }
          >
            <strong>Sistema de Gestión de Desempeño</strong>
          </Button>
        </div>
      </Popover>
    </Fragment>
  );
}
